@if (acceptancesWithControls().length > 0) {
  <div
    class="acceptances-block"
    role="group"
    [attr.aria-label]="acceptancesSectionTitle()"
  >
    <div class="acceptances-block__title">{{ acceptancesSectionTitle() }}</div>

    @if (acceptancesSectionDescription()) {
      <div class="acceptances-block__description" [innerHTML]="acceptancesSectionDescription()"></div>
    }

    <div class="acceptances-block__list">
      @for (item of acceptancesWithControls(); track item.acc.key) {
        <app-acceptance-field
          [acceptance]="item.acc"
          [control]="item.control"
          [snapshot]="svc.snapshot()"
        />
      }
    </div>

    @if (acceptancesSectionNote()) {
      <div class="acceptances-block__note">{{ acceptancesSectionNote() }}</div>
    }
  </div>
}
